export const BILL_TYPE = [
  { value: "Paid", label: "Paid" },
  { value: "Unpaid", label: "Unpaid" },
  { value: "Part Paid", label: "Part Paid" },
];
export const STATUS_TYPE = [
  { value: "Paid", label: "Paid" },
  { value: "Unpaid", label: "Unpaid" },
];
export const VEHICLE_STATUS = [
  { value: "running", label: "Running" },
  { value: "expired", label: "Expired" },
];
export const EXPENSE_TYPE = [
  { value: "Office", label: "Office" },
  { value: "Personal", label: "Personal" },
];
